<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label">
        <b-breadcrumb :items="pages" style="margin: 0px; padding: 5px 14px;"></b-breadcrumb>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-2">
              <div class="label mt-2">Select GRO Site:</div>
              <div class="sub-label"></div>
              <b-form-select v-model="GRO" :options="GRO_options"
                label="Select GRO Site:" @change="onChangeGRO"></b-form-select>
            </div>
            <div class="col-2">
              <div class="label mt-2">SA:</div>
              <b-form-select v-model="member" :options="member_options" label="SA:" @change="onChangeMember"></b-form-select>
            </div>
            <div class="col-auto align-self-end mx-xs-5">
              <b-button @click="$emit('editSignFlowModal', member)" variant="primary">Add New</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="table_show==true">

      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fields" :items="SignFlowData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(gro_sa)="data">
            <span>
              {{data.item.gro_sa}}
            </span>
          </template>

          <template #cell(espm)="data">
            <span>
              {{data.item.espm}}
            </span>
          </template>

          <template #cell(espm_leader)="data">
            <span>
              {{data.item.espm_leader}}
            </span>
          </template>

          <template #cell(hq_sales)="data">
            <span>
              {{data.item.hq_sales}}
            </span>
          </template>

          <template #cell(gro_sa_leader)="data">
            <span>
              {{data.item.gro_sa_leader}}
            </span>
          </template>

          <template #cell(gro_rsm)="data">
            <span>
              {{data.item.gro_rsm}}
            </span>
          </template>

          <template #cell(gro_sales_director)="data">
            <span>
              {{data.item.gro_sales_director}}
            </span>
          </template>

          <template #cell(gro_director_header)="data">
            <span>
              {{data.item.gro_director_header}}
            </span>
          </template>

          <template #cell(gro_sa_leader_conf)="data">
            <span>
              {{data.item.gro_sa_leader_conf}}
            </span>
          </template>

          <template #cell(hq_sales_conf)="data">
            <span>
              {{data.item.hq_sales_conf}}
            </span>
          </template>

          <template #cell(espm_kickoff)="data">
            <span>
              {{data.item.espm_kickoff}}
            </span>
          </template>

          <template #cell(action)="data">
            <button  type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                @click="$emit('editSignFlowModal', data.item)"></button>
            <button  type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete"
                @click="$emit('deleteModal', 'nre', data.item, member)"></button>
          </template>

        </b-table>
      </div>
    </div>

    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'admin',
    props: ['SignFlowData', 'member_options', 'table_show', ],
    watch: { 
      member_options: function(newVal, oldVal) { // watch it
        this.member = newVal[0].value
        console.log(newVal)
      }
    },
    data() {
      return {
        // function_name: 'Admin-Member NRE Sign Flow',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        authUrl: '',
        frontendUrl: '',
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        GRO_options_default: '',
        GRO_options: [{ value: '', text: '---Select One---' }],
        GRO: '',
        GROText: '',
        member: '',

        pages: [
          { text: 'Admin-Member Setting', href: '' },
          { text: 'NRE Sign Flow', active: true }
        ],

        fields: [
          { key: 'uni_id', label: '#', thClass: 'align-middle', sortable: true },
          { key: 'gro_sa', label: 'GRO SA', thClass: 'align-middle', sortable: true },
          { key: 'espm', label: 'ES PM', thClass: 'align-middle', sortable: true },
          { key: 'espm_leader', label: 'ES PM Leader Review', thClass: 'align-middle', sortable: false },
          { key: 'hq_sales', label: 'HQ Sales Review', thClass: 'align-middle', sortable: true },
          { key: 'gro_sa_leader', label: 'GRO SA Leader Review', thClass: 'align-middle', sortable: true },
          { key: 'gro_rsm', label: 'GRO RSM', thClass: 'align-middle', sortable: false },
          { key: 'gro_sales_director', label: 'GRO Sales Director', thClass: 'align-middle', sortable: true },
          { key: 'gro_director_header', label: 'GRO Director Header', thClass: 'align-middle', sortable: true },
          { key: 'gro_sa_leader_conf', label: 'GRO SA Leader Confirmation', thClass: 'align-middle', sortable: true },
          { key: 'hq_sales_conf', label: 'HQ Sales Confirmation', thClass: 'align-middle', sortable: true },
          { key: 'espm_kickoff', label: 'ES PM Kickoff', thClass: 'align-middle', sortable: true },
          { key: 'action', label: 'Actions', thClass: 'align-middle', sortable: false }
        ],
        login_user_name: '',
        searching: false,
        pageDisabled: true,
      }
    },
    created() {
      let self = this;

    },
    computed: {

    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.pages[0]['href'] = this.$root.frontEndUrl + "/admin-member/setting"
    },
    methods: {
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location.href = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);

        this.login_user_name = user_name;
        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var gro_option_new = new Array();
        for (i = 0; i < options.gro_opt_val_list.length; i++) {
          gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        gro_option_new[0].text = '---Select One---'
        this.GRO_options = gro_option_new;
        this.GRO_options_default = gro_option_new[0];
        this.GRO = gro_option_new[0].value;
        this.GROText = gro_option_new[0].text;

      },
      onChangeGRO(GRO) {
        let self = this;
        let groText = GRO
        self.GRO = GRO
        if('' === GRO){
          groText = '---Select One---';
        }
        else {
          let request_data = {
            action: 'load',
            GRO: self.GRO,
            member: ''
          };
          self.$parent.getNRE(request_data)
        }
      },
      onChangeMember(member) {
        let self = this;
        let memberText = member;
        self.member = member
        if('' === member){
          memberText = '---Select All---';
        }
        let request_data = {
          action: '',
          GRO: self.GRO,
          member: self.member
        };
        self.$parent.getNRE(request_data)
      },
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NRESignFlow.vue